import React, { Fragment } from 'react'
import { CalendarMonthRounded, ConfirmationNumberRounded, Menu, PeopleAltRounded, Star, WatchLaterRounded } from '@mui/icons-material'
import { toast } from 'react-toastify'
import { ENDPOINT } from '../../constants'
import { useAuth } from '../../contexts/AuthContext'
import { FetchApi } from '../../api/fetch'


type Props = {
   data: any;
   getCourses: () => void
}



function FeaturedCourseCard({ data, getCourses }: Props) {
   const { setIsLoadingOverlayDisplay, getUserJWT } = useAuth()

   const deleteFeatured = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      const reqBody = {
         id: data.id,
         name: data.name,
         description: data.description,
         project_name: data.projectName,
         project_website: data.projectWebsite,
         number_of_ticket_award: data.numberOfTicketAward,
         max_attendees: data.maxAttendees,
         start_date: data.startDate,
         end_date: data.endDate,
         logo_url: data.logoURL,
         banner_url: data.bannerURL,
         position: data.position,
         featured_position: data.featuredPosition,
         category_id: data.categoryIds,
         sub_category_id: data.subCategoryIds,
         is_featured: false,
         no_max_attendees: data.noMaxAttendees,
         no_expiry: data.noExpiry,
         time_required: data.timeRequired
      }
      try {
         const data = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${reqBody?.id}/edit-course`,
            method: "PATCH",
            JWT: userJWT,
            body:  (reqBody)
         })


         if (data.success) {
            getCourses()
            toast.success(data.message)
         }
      } catch (error: any) {
         toast.error(error.message)
      }
      setIsLoadingOverlayDisplay(false)
   }

   return (
      <Fragment>

         <div className="bg-gray-90 flex items-start justify-between p-4 my-4 rounded-lg">
            <div className='flex items-center w-full gap-3'>
               <div>
                  <Menu className="h-8 text-gray-50" />
               </div>
               <div className="flex items-center w-full gap-3">
                  <div className="w-3/12 h-36 rounded-md" style={{
                     backgroundImage: `url('${data?.bannerURL}')`,
                     backgroundSize: 'contain',
                     backgroundPosition: `center`,
                     backgroundRepeat: 'no-repeat'

                  }}>
                     {/* <img src='/assets/thumbnails/rainbowGirls.jpeg' className="rounded-md w-full h-36" /> */}
                  </div>
                  <div className='w-full'>
                     <div className='flex flex-wrap items-center justify-between gap-3 mb-2'>
                        <div className='flex gap-2 items-center'>
                           <p className='text-md font-normal'>{data.name}</p>
                           {
                              data.isFeatured &&
                              <span className='block flex items-center gap-1 px-2 py-1 border border-yellow-500 rounded-lg text-xs text-yellow-500'>Featured <Star className='text-yellow-500' fontSize='small' /></span>
                           }
                        </div>
                     </div>
                     <p className="font-extralight text-sm text-gray-40 mb-2">
                        {data.description}
                     </p>
                     <div className='flex items-center gap-3 my-2 text-sm'>
                        <div className='flex items-center gap-2'>
                           <div className="w-6 h-6">
                              <img src={data.logoURL} alt='logo' className="rounded-full w-6 h-6" />
                           </div>
                           <span className='text-md font-light text-blue-500'>{data.projectName}</span>
                        </div>
                        <div className='flex items-center gap-2'>
                           <WatchLaterRounded className='w-5' />
                           <span className='text-md'>{data.timeRequired || 0} min</span>
                        </div>
                        <div className='flex items-center gap-1'>
                           <ConfirmationNumberRounded className='w-5 text-accent-green' />
                           <span className='text-md'>{data.numberOfTicketAward} Tickets</span>
                        </div>
                        <div className='flex items-center gap-2'>
                           <PeopleAltRounded className='w-5' />
                           <span className='text-md'>{data.noOfAttempted} / {data.noMaxAttendees ? 'Infinite Attendees' : `${data.maxAttendees} Attendees (max)`} </span>
                        </div>
                     </div>
                     <div className='flex items-center gap-2 text-sm'>
                        <CalendarMonthRounded className='w-5' />
                        <p className='text-md font-normal flex gap-4 items-center wrap'> {new Date(data.startDate).toUTCString().replace('GMT', 'UTC')} <span className='text-xl font-medium'>-</span> {data.noExpiry ? 'No Expiry' : new Date(data.endDate).toUTCString().replace('GMT', 'UTC')}</p>
                     </div>
                  </div>
               </div>
               <div>
                  <button onClick={deleteFeatured} className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21.07 5.23c-1.61-.16-3.22-.28-4.84-.37v-.01l-.22-1.3c-.15-.92-.37-2.3-2.71-2.3h-2.62c-2.33 0-2.55 1.32-2.71 2.29l-.21 1.28c-.93.06-1.86.12-2.79.21l-2.04.2c-.42.04-.72.41-.68.82.04.41.4.71.82.67l2.04-.2c5.24-.52 10.52-.32 15.82.21h.08c.38 0 .71-.29.75-.68a.766.766 0 0 0-.69-.82ZM19.23 8.14c-.24-.25-.57-.39-.91-.39H5.68c-.34 0-.68.14-.91.39-.23.25-.36.59-.34.94l.62 10.26c.11 1.52.25 3.42 3.74 3.42h6.42c3.49 0 3.63-1.89 3.74-3.42l.62-10.25c.02-.36-.11-.7-.34-.95Zm-5.57 9.61h-3.33c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.33c.41 0 .75.34.75.75s-.34.75-.75.75Zm.84-4h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75Z" fill="#667085"></path></svg>

                     Delete
                  </button>
               </div>
            </div>
         </div>

      </Fragment>
   )
}

export default FeaturedCourseCard